import _objectWithoutProperties from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["state", "focusable", "modal", "portal", "backdrop", "backdropProps", "hideOnEscape", "hideOnInteractOutside", "preventBodyScroll", "autoFocusOnShow", "autoFocusOnHide", "initialFocusRef", "finalFocusRef"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useRef, useEffect, useMemo, useCallback, useContext, useState, createContext } from 'react';
import { getDocument, contains, getActiveElement, getWindow, isButton, closest } from 'ariakit-utils/dom';
import { addGlobalEventListener, isSelfTarget, queueBeforeEvent } from 'ariakit-utils/events';
import { getFirstTabbableIn, focusIfNeeded, isFocusable } from 'ariakit-utils/focus';
import { useSafeLayoutEffect, useBooleanEvent, useEvent, useForkRef, useForceUpdate, useLiveRef, usePortalRef, useId, useWrapElement } from 'ariakit-utils/hooks';
import { noop, chain } from 'ariakit-utils/misc';
import { isApple, isMac, isSafari } from 'ariakit-utils/platform';
import { createHook, createComponent, createElement } from 'ariakit-utils/system';
import { useDisclosureContent } from '../disclosure/disclosure-content.js';
import { useFocusTrapRegion } from '../focus-trap/focus-trap-region.js';
import { useFocusable } from '../focusable/focusable.js';
import { HeadingLevel } from '../heading/heading-level.js';
import { usePortal } from '../portal/portal.js';
import { jsx } from 'react/jsx-runtime';
import { D as DialogContext, a as DialogHeadingContext, b as DialogDescriptionContext } from '../dialog-context-f963dd70.js';
import { flushSync } from 'react-dom';

function usePreviousMouseDownRef(enabled) {
  var previousMouseDownRef = useRef();
  useEffect(function () {
    if (!enabled) {
      previousMouseDownRef.current = null;
      return;
    }

    var onMouseDown = function onMouseDown(event) {
      previousMouseDownRef.current = event.target;
    };

    return addGlobalEventListener("mousedown", onMouseDown, true);
  }, [enabled]);
  return previousMouseDownRef;
}

function DialogBackdrop(_ref) {
  var _state$contentElement;

  var state = _ref.state,
      backdrop = _ref.backdrop,
      backdropProps = _ref.backdropProps,
      _ref$hideOnInteractOu = _ref.hideOnInteractOutside,
      hideOnInteractOutside = _ref$hideOnInteractOu === void 0 ? true : _ref$hideOnInteractOu,
      _ref$hideOnEscape = _ref.hideOnEscape,
      hideOnEscape = _ref$hideOnEscape === void 0 ? true : _ref$hideOnEscape,
      hidden = _ref.hidden,
      children = _ref.children;
  var ref = useRef(null);
  state = useMemo(function () {
    return _objectSpread(_objectSpread({}, state), {}, {
      // Override the setContentElement method to prevent the backdrop from
      // overwriting the dialog's content element.
      setContentElement: noop
    });
  }, [state]);
  useSafeLayoutEffect(function () {
    var backdrop = ref.current;
    var dialog = state.contentElement;
    if (!backdrop) return;
    if (!dialog) return;
    backdrop.style.zIndex = getComputedStyle(dialog).zIndex;
  }, [state.contentElement]);
  var onClickProp = backdropProps == null ? void 0 : backdropProps.onClick;
  var hideOnInteractOutsideProp = useBooleanEvent(hideOnInteractOutside);
  var previousMouseDownRef = usePreviousMouseDownRef(state.mounted);
  var onClick = useEvent(function (event) {
    onClickProp == null ? void 0 : onClickProp(event);
    if (event.defaultPrevented) return;
    if (!isSelfTarget(event)) return;
    if (previousMouseDownRef.current !== event.currentTarget) return;
    if (!hideOnInteractOutsideProp(event)) return;
    event.stopPropagation();
    state.hide();
  });
  var onKeyDownProp = backdropProps == null ? void 0 : backdropProps.onKeyDown;
  var hideOnEscapeProp = useBooleanEvent(hideOnEscape); // When hideOnInteractOutside is false and the backdrop is clicked, the
  // backdrop will receive focus (because we set the tabIndex on it). Therefore,
  // the Escape key will not be captured by the Dialog component. So we listen
  // to it here.

  var onKeyDown = useEvent(function (event) {
    onKeyDownProp == null ? void 0 : onKeyDownProp(event);
    if (event.defaultPrevented) return;
    if (event.key !== "Escape") return;
    if (!isSelfTarget(event)) return;
    if (!hideOnEscapeProp(event)) return;
    state.hide();
  });
  var props = useDisclosureContent(_objectSpread(_objectSpread({
    state: state,
    id: undefined,
    role: "presentation",
    tabIndex: -1,
    hidden: hidden
  }, backdropProps), {}, {
    ref: useForkRef(backdropProps == null ? void 0 : backdropProps.ref, ref),
    onClick: onClick,
    onKeyDown: onKeyDown,
    style: _objectSpread({
      position: "fixed",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }, backdropProps == null ? void 0 : backdropProps.style)
  }));
  var Component = typeof backdrop !== "boolean" ? backdrop || "div" : "div";
  return /*#__PURE__*/jsx(Component, _objectSpread(_objectSpread({}, props), {}, {
    "data-backdrop": (_state$contentElement = state.contentElement) == null ? void 0 : _state$contentElement.id,
    children: children
  }));
} // We don't need to walk through certain tags.


var ignoreTags = ["SCRIPT", "STYLE"];

function isValidElement(element, ignoredElements) {
  if (ignoreTags.includes(element.tagName)) return false;
  return !ignoredElements.some(function (enabledElement) {
    return enabledElement && contains(element, enabledElement);
  });
}

function walkTreeOutside(elements, callback) {
  var _iterator = _createForOfIteratorHelper(elements),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var element = _step.value;
      var document = getDocument(element); // Loops through the parent elements and then through each of their
      // children.

      while ((_element = element) != null && _element.parentElement && element !== document.body) {
        var _element;

        var _iterator2 = _createForOfIteratorHelper(element.parentElement.children),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var child = _step2.value;

            if (isValidElement(child, elements)) {
              callback(child);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        element = element.parentElement;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

function disableElement$1(element) {
  var previousAriaHidden = element.getAttribute("aria-hidden") || "";
  element.setAttribute("aria-hidden", "true");

  var enableElement = function enableElement() {
    if (previousAriaHidden) {
      element.setAttribute("aria-hidden", previousAriaHidden);
    } else {
      element.removeAttribute("aria-hidden");
    }
  };

  return enableElement;
}

function disableAccessibilityTreeOutside() {
  var cleanups = [];

  for (var _len = arguments.length, elements = new Array(_len), _key = 0; _key < _len; _key++) {
    elements[_key] = arguments[_key];
  }

  walkTreeOutside(elements, function (element) {
    cleanups.unshift(disableElement$1(element));
  });

  var restoreAccessibilityTree = function restoreAccessibilityTree() {
    cleanups.forEach(function (fn) {
      return fn();
    });
  };

  return restoreAccessibilityTree;
}

function disableElement(element) {
  if (!("style" in element)) return noop;
  var previousPointerEvents = element.style.pointerEvents;
  element.style.pointerEvents = "none";

  var enableElement = function enableElement() {
    element.style.pointerEvents = previousPointerEvents != null ? previousPointerEvents : "";
  };

  return enableElement;
}

function disablePointerEventsOutside() {
  var cleanups = [];

  for (var _len = arguments.length, elements = new Array(_len), _key = 0; _key < _len; _key++) {
    elements[_key] = arguments[_key];
  }

  walkTreeOutside(elements, function (element) {
    cleanups.unshift(disableElement(element));
  });

  var restorePointerEvents = function restorePointerEvents() {
    cleanups.forEach(function (fn) {
      return fn();
    });
  };

  return restorePointerEvents;
}

function prependHiddenDismiss(container, onClick) {
  var document = getDocument(container);
  var button = document.createElement("button");
  button.type = "button";
  button.tabIndex = -1;
  button.textContent = "Dismiss popup"; // Visually hidden styles

  button.style.border = "0px";
  button.style.clip = "rect(0 0 0 0)";
  button.style.height = "1px";
  button.style.margin = "-1px";
  button.style.overflow = "hidden";
  button.style.padding = "0px";
  button.style.position = "absolute";
  button.style.whiteSpace = "nowrap";
  button.style.width = "1px";
  button.addEventListener("click", onClick);
  container.prepend(button);

  var removeHiddenDismiss = function removeHiddenDismiss() {
    button.removeEventListener("click", onClick);
    button.remove();
  };

  return removeHiddenDismiss;
}
/**
 * Controls which dialog is the champion that will control global behavior such
 * as body scrolling and accessibility tree outside.
 */


function useChampionDialog(dialogRef, attribute, enabled) {
  var _useForceUpdate = useForceUpdate(),
      _useForceUpdate2 = _slicedToArray(_useForceUpdate, 2),
      updated = _useForceUpdate2[0],
      retry = _useForceUpdate2[1];

  var isChampionDialog = useCallback(function () {
    if (!enabled) return false;
    var dialog = dialogRef.current;
    if (!dialog) return false;

    var _getDocument = getDocument(dialog),
        body = _getDocument.body;

    var id = body.getAttribute(attribute);
    return !id || id === dialog.id;
  }, [updated, enabled, attribute]);
  useSafeLayoutEffect(function () {
    var dialog = dialogRef.current;
    if (!dialog) return;
    if (!enabled) return;

    var _getDocument2 = getDocument(dialog),
        body = _getDocument2.body;

    if (!isChampionDialog()) {
      var observer = new MutationObserver(function () {
        return flushSync(retry);
      });
      observer.observe(body, {
        attributeFilter: [attribute]
      });
      return function () {
        return observer.disconnect();
      };
    }

    body.setAttribute(attribute, dialog.id);
    return function () {
      body.removeAttribute(attribute);
    };
  }, [updated, dialogRef, enabled, isChampionDialog, attribute]);
  return isChampionDialog;
}
/**
 * When the focused child gets removed from the DOM, we make sure to move focus
 * to the dialog.
 */


function useFocusOnChildUnmount(dialogRef, state) {
  useEffect(function () {
    if (!state.open) return;
    var dialog = dialogRef.current;
    if (!dialog) return;
    var observer = new MutationObserver(function (_ref) {
      var _ref3 = _slicedToArray(_ref, 1),
          mutation = _ref3[0];

      if (!mutation) return; // If target is not dialog, then this observer was triggered by a nested
      // dialog, so we just ignore it here and let the nested dialog handle it.

      if (mutation.target !== dialog) return;
      var document = getDocument(dialog);
      var activeElement = getActiveElement(dialog); // We can check if the current focused element is the document body.

      if (activeElement === document.body) {
        dialog.focus();
      }
    });
    observer.observe(dialog, {
      childList: true,
      subtree: true
    });
    return function () {
      return observer.disconnect();
    };
  }, [state.open, dialogRef]);
}

function isInDocument(target) {
  if (target.tagName === "HTML") return true;
  return contains(getDocument(target).body, target);
}

function isDisclosure(disclosure, target) {
  if (contains(disclosure, target)) return true;
  var activeId = target.getAttribute("aria-activedescendant");

  if (activeId) {
    var activeElement = getDocument(disclosure).getElementById(activeId);

    if (activeElement) {
      return contains(disclosure, activeElement);
    }
  }

  return false;
}

function isBackdrop$1(dialog, target) {
  if (!dialog) return false;
  if (!target) return false;
  return target.hasAttribute("data-backdrop") && target.getAttribute("data-backdrop") === dialog.id;
}

function dialogContains(target) {
  return function (dialogRef) {
    var dialog = dialogRef.current;
    if (!dialog) return false;
    if (contains(dialog, target)) return true;
    if (isBackdrop$1(dialog, target)) return true;
    return false;
  };
}

function useEventOutside(_ref) {
  var type = _ref.type,
      listener = _ref.listener,
      dialogRef = _ref.dialogRef,
      nestedDialogs = _ref.nestedDialogs,
      disclosureRef = _ref.disclosureRef,
      enabled = _ref.enabled,
      capture = _ref.capture;
  var callListener = useEvent(listener);
  var nestedDialogsRef = useLiveRef(nestedDialogs);
  useEffect(function () {
    if (!enabled) return;

    var onEvent = function onEvent(event) {
      var container = dialogRef.current;
      var disclosure = disclosureRef == null ? void 0 : disclosureRef.current;
      var target = event.target;
      if (!container) return;
      if (!target) return; // When an element is unmounted right after it receives focus, the focus
      // event is triggered after that, when the element isn't part of the
      // current document anymore. We just ignore it.

      if (!isInDocument(target)) return; // Event inside dialog

      if (contains(container, target)) return; // Event on disclosure

      if (disclosure && isDisclosure(disclosure, target)) return; // Event on focus trap

      if (target.hasAttribute("data-focus-trap")) return; // Event inside a nested dialog

      if (nestedDialogsRef.current.some(dialogContains(target))) return;
      callListener(event);
    };

    return addGlobalEventListener(type, onEvent, capture);
  }, [enabled, dialogRef, disclosureRef, callListener, capture]);
}

function shouldHideOnInteractOutside(hideOnInteractOutside, event) {
  if (typeof hideOnInteractOutside === "function") {
    return hideOnInteractOutside(event);
  }

  return !!hideOnInteractOutside;
}

function useHideOnInteractOutside(dialogRef, nestedDialogs, _ref2) {
  var state = _ref2.state,
      modal = _ref2.modal,
      hideOnInteractOutside = _ref2.hideOnInteractOutside,
      _ref2$enabled = _ref2.enabled,
      enabled = _ref2$enabled === void 0 ? state.open : _ref2$enabled;
  var previousMouseDownRef = usePreviousMouseDownRef(enabled);
  var props = {
    disclosureRef: state.disclosureRef,
    enabled: enabled,
    dialogRef: dialogRef,
    nestedDialogs: nestedDialogs,
    capture: true
  };
  useEventOutside(_objectSpread(_objectSpread({}, props), {}, {
    type: "mousedown",
    listener: function listener(event) {
      var dialog = dialogRef.current;
      if (!dialog) return;

      if (modal && !shouldHideOnInteractOutside(hideOnInteractOutside, event)) {
        // If the dialog is modal and the user clicked outside the dialog, but
        // shouldHideOnInteractOutside is false, we don't hide the dialog, but
        // ensure focus is placed on it. Otherwise the focus might end up on an
        // element outside of the dialog or the body element itself.
        dialog.focus();
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }));
  useEventOutside(_objectSpread(_objectSpread({}, props), {}, {
    type: "click",
    listener: function listener(event) {
      var previousMouseDown = previousMouseDownRef.current; // If there's no previously mousedown'd element, this probably means that
      // the dialog opened with a mousedown event, and a subsequent click event
      // was dispatched outside of the dialog. See form-select example. We just
      // ignore this.

      if (!previousMouseDown) return;

      if (!shouldHideOnInteractOutside(hideOnInteractOutside, event)) {
        if (!modal) return;
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      var dialog = dialogRef.current;
      var draggingFromDialog = dialog && contains(dialog, previousMouseDown); // This prevents the dialog from closing by dragging the cursor (for
      // example, selecting some text inside the dialog and releasing the mouse
      // outside of it). See https://github.com/ariakit/ariakit/issues/1336

      if (draggingFromDialog) return;
      state.hide();
    }
  }));
  useEventOutside(_objectSpread(_objectSpread({}, props), {}, {
    type: "focusin",
    listener: function listener(event) {
      var dialog = dialogRef.current;
      if (!dialog) return;

      if (!shouldHideOnInteractOutside(hideOnInteractOutside, event)) {
        if (!modal) return; // Same as the mousedown listener.

        dialog.focus();
        event.preventDefault();
        event.stopPropagation();
        return;
      } // Fix for https://github.com/ariakit/ariakit/issues/619


      if (event.target === getDocument(dialog)) return;
      state.hide();
    }
  }));
  useEventOutside(_objectSpread(_objectSpread({}, props), {}, {
    type: "contextmenu",
    listener: function listener(event) {
      var dialog = dialogRef.current;
      if (!dialog) return;

      if (!shouldHideOnInteractOutside(hideOnInteractOutside, event)) {
        if (!modal) return; // Same as the mousedown listener.

        dialog.focus();
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      state.hide();
    }
  }));
}

var NestedDialogsContext = /*#__PURE__*/createContext({});
/**
 * Handles nested dialogs.
 */

function useNestedDialogs(dialogRef, _ref) {
  var state = _ref.state,
      modal = _ref.modal;
  var context = useContext(NestedDialogsContext);

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      openModals = _useState2[0],
      setOpenModals = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      nestedDialogs = _useState4[0],
      setNestedDialogs = _useState4[1];

  var addDialog = useCallback(function (ref) {
    var removeFromContext = context.addDialog == null ? void 0 : context.addDialog(ref);
    setNestedDialogs(function (dialogs) {
      return [].concat(_toConsumableArray(dialogs), [ref]);
    });
    return function () {
      removeFromContext == null ? void 0 : removeFromContext();
      setNestedDialogs(function (dialogs) {
        return dialogs.filter(function (dialog) {
          return dialog !== ref;
        });
      });
    };
  }, [context.addDialog]);
  var showModal = useCallback(function (ref) {
    var hideModal = context.showModal == null ? void 0 : context.showModal(ref);
    setOpenModals(function (modals) {
      return [].concat(_toConsumableArray(modals), [ref]);
    });
    return function () {
      hideModal == null ? void 0 : hideModal();
      setOpenModals(function (modals) {
        return modals.filter(function (modal) {
          return modal !== ref;
        });
      });
    };
  }, [context.showModal]); // If this is a nested dialog, add it to the context.

  useSafeLayoutEffect(function () {
    return context.addDialog == null ? void 0 : context.addDialog(dialogRef);
  }, [context.addDialog, dialogRef]);
  useSafeLayoutEffect(function () {
    if (!modal) return;
    if (!state.open) return;
    return context.showModal == null ? void 0 : context.showModal(dialogRef);
  }, [modal, state.open, context.showModal, dialogRef]); // Close all nested dialogs when parent dialog closes.

  useSafeLayoutEffect(function () {
    if (context.open === false && state.open) {
      state.hide();
    }
  }, [context.open, state.open, state.hide]); // Provider

  var providerValue = useMemo(function () {
    return {
      open: state.open,
      addDialog: addDialog,
      showModal: showModal
    };
  }, [state.open, addDialog, showModal]);
  var wrapElement = useCallback(function (element) {
    return /*#__PURE__*/jsx(NestedDialogsContext.Provider, {
      value: providerValue,
      children: element
    });
  }, [providerValue]);
  return {
    nestedDialogs: nestedDialogs,
    openModals: openModals,
    wrapElement: wrapElement
  };
} // Based on https://github.com/floating-ui/floating-ui/blob/1201e72e67a80e479122293d46d96c9bbc8f156d/packages/react-dom-interactions/src/FloatingOverlay.tsx


function assignStyle(element, style) {
  if (!element) return function () {};
  var previousStyle = element.style.cssText;
  Object.assign(element.style, style);
  return function () {
    element.style.cssText = previousStyle;
  };
}

function setCSSProperty(element, property, value) {
  if (!element) return function () {};
  var previousValue = element.style.getPropertyValue(property);
  element.style.setProperty(property, value);
  return function () {
    if (previousValue) {
      element.style.setProperty(property, previousValue);
    } else {
      element.style.removeProperty(property);
    }
  };
}

function getPaddingProperty(documentElement) {
  // RTL <body> scrollbar
  var documentLeft = documentElement.getBoundingClientRect().left;
  var scrollbarX = Math.round(documentLeft) + documentElement.scrollLeft;
  return scrollbarX ? "paddingLeft" : "paddingRight";
}

function usePreventBodyScroll(dialogRef, enabled) {
  var isChampionDialog = useChampionDialog(dialogRef, "data-dialog-body-scroll", enabled);
  useSafeLayoutEffect(function () {
    var dialog = dialogRef.current;
    if (!dialog) return;
    if (!isChampionDialog()) return;
    var doc = getDocument(dialog);
    var win = getWindow(dialog);
    var documentElement = doc.documentElement,
        body = doc.body;
    var scrollbarWidth = win.innerWidth - documentElement.clientWidth;

    var setScrollbarWidthProperty = function setScrollbarWidthProperty() {
      return setCSSProperty(documentElement, "--scrollbar-width", scrollbarWidth + "px");
    };

    var paddingProperty = getPaddingProperty(documentElement);

    var setStyle = function setStyle() {
      return assignStyle(body, _defineProperty({
        overflow: "hidden"
      }, paddingProperty, scrollbarWidth + "px"));
    }; // Only iOS doesn't respect `overflow: hidden` on document.body


    var setIOSStyle = function setIOSStyle() {
      var _visualViewport$offse, _visualViewport$offse2;

      var scrollX = win.scrollX,
          scrollY = win.scrollY,
          visualViewport = win.visualViewport; // iOS 12 does not support `visuaViewport`.

      var offsetLeft = (_visualViewport$offse = visualViewport == null ? void 0 : visualViewport.offsetLeft) != null ? _visualViewport$offse : 0;
      var offsetTop = (_visualViewport$offse2 = visualViewport == null ? void 0 : visualViewport.offsetTop) != null ? _visualViewport$offse2 : 0;
      var restoreStyle = assignStyle(body, _defineProperty({
        position: "fixed",
        overflow: "hidden",
        top: -(scrollY - Math.floor(offsetTop)) + "px",
        left: -(scrollX - Math.floor(offsetLeft)) + "px",
        right: "0"
      }, paddingProperty, scrollbarWidth + "px"));
      return function () {
        restoreStyle(); // istanbul ignore next: JSDOM doesn't implement window.scrollTo

        if (process.env.NODE_ENV !== "test") {
          win.scrollTo(scrollX, scrollY);
        }
      };
    };

    var isIOS = isApple() && !isMac();
    return chain(setScrollbarWidthProperty(), isIOS ? setIOSStyle() : setStyle());
  }, [dialogRef, isChampionDialog]);
}

var isSafariBrowser = isSafari();

function isBackdrop(dialog, element) {
  var id = dialog.id;
  if (!id) return;
  return element.getAttribute("data-backdrop") === id;
}

function isInDialog(element) {
  return function (dialogRef) {
    return dialogRef.current && contains(dialogRef.current, element);
  };
}

function isAlreadyFocusingAnotherElement(dialog, nestedDialogs) {
  var activeElement = getActiveElement();
  if (!activeElement) return false;
  if (contains(dialog, activeElement)) return false;
  if (isBackdrop(dialog, activeElement)) return false;
  if (nestedDialogs != null && nestedDialogs.some(isInDialog(activeElement))) return false;
  if (isFocusable(activeElement)) return true;
  return false;
}
/**
 * A component hook that returns props that can be passed to `Role` or any other
 * Ariakit component to render a dialog element.
 * @see https://ariakit.org/components/dialog
 * @example
 * ```jsx
 * const state = useDialogState();
 * const props = useDialog({ state });
 * <Role {...props}>Dialog</Role>
 * ```
 */


var useDialog = createHook(function (_ref) {
  var state = _ref.state,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? true : _ref$focusable,
      _ref$modal = _ref.modal,
      modal = _ref$modal === void 0 ? true : _ref$modal,
      _ref$portal = _ref.portal,
      portal = _ref$portal === void 0 ? !!modal : _ref$portal,
      _ref$backdrop = _ref.backdrop,
      backdrop = _ref$backdrop === void 0 ? !!modal : _ref$backdrop,
      backdropProps = _ref.backdropProps,
      _ref$hideOnEscape2 = _ref.hideOnEscape,
      hideOnEscape = _ref$hideOnEscape2 === void 0 ? true : _ref$hideOnEscape2,
      _ref$hideOnInteractOu2 = _ref.hideOnInteractOutside,
      hideOnInteractOutside = _ref$hideOnInteractOu2 === void 0 ? true : _ref$hideOnInteractOu2,
      _ref$preventBodyScrol = _ref.preventBodyScroll,
      preventBodyScroll = _ref$preventBodyScrol === void 0 ? !!modal : _ref$preventBodyScrol,
      _ref$autoFocusOnShow = _ref.autoFocusOnShow,
      autoFocusOnShow = _ref$autoFocusOnShow === void 0 ? true : _ref$autoFocusOnShow,
      _ref$autoFocusOnHide = _ref.autoFocusOnHide,
      autoFocusOnHide = _ref$autoFocusOnHide === void 0 ? true : _ref$autoFocusOnHide,
      initialFocusRef = _ref.initialFocusRef,
      finalFocusRef = _ref.finalFocusRef,
      props = _objectWithoutProperties(_ref, _excluded);

  var ref = useRef(null);
  var openRef = useRef(state.open); // domReady can be also the portal node element so it's updated when the
  // portal node changes (like in between re-renders), triggering effects
  // again.

  var _usePortalRef = usePortalRef(portal, props.portalRef),
      portalRef = _usePortalRef.portalRef,
      portalNode = _usePortalRef.portalNode,
      domReady = _usePortalRef.domReady; // Sets preserveTabOrder to true only if the dialog is not a modal and is
  // open.


  var preserveTabOrder = props.preserveTabOrder && !modal && state.mounted;
  var openStable = state.open && !state.animating; // Usually, we only want to disable the accessibility tree outside if the
  // dialog is a modal. But the Portal component can't preserve the tab order
  // on Safari/VoiceOver. By allowing only the dialog/portal to be accessible,
  // we provide a similar tab order flow. We don't need to disable pointer
  // events because it's just for screen readers.

  var shouldDisableAccessibilityTree = modal || portal && preserveTabOrder && isSafari();
  var id = useId(props.id); // Sets disclosure ref. It needs to be a layout effect so we get the focused
  // element right before the dialog is mounted.

  useSafeLayoutEffect(function () {
    if (!openStable) return;
    var dialog = ref.current;
    var activeElement = getActiveElement(dialog, true);
    if (!activeElement) return;
    if (activeElement.tagName === "BODY") return; // The disclosure element can't be inside the dialog.

    if (dialog && contains(dialog, activeElement)) return;
    state.disclosureRef.current = activeElement;
  }, [openStable]);
  var nested = useNestedDialogs(ref, {
    state: state,
    modal: modal
  });
  var nestedDialogs = nested.nestedDialogs,
      openModals = nested.openModals,
      wrapElement = nested.wrapElement;
  var nestedDialogsRef = useLiveRef(nestedDialogs);
  usePreventBodyScroll(ref, preventBodyScroll && state.mounted); // When a focused child element is removed, focus will be placed on the
  // document's body. This will focus on the dialog instead.

  useFocusOnChildUnmount(ref, state);
  useHideOnInteractOutside(ref, nestedDialogs, {
    state: state,
    modal: modal,
    hideOnInteractOutside: hideOnInteractOutside,
    enabled: state.open
  }); // Safari does not focus on native buttons on mousedown. The
  // DialogDisclosure component normalizes this behavior using the
  // useFocusable hook, but the disclosure button may use a custom component,
  // and not DialogDisclosure. In this case, we need to make sure the
  // disclosure button gets focused here.

  if (isSafariBrowser) {
    useEffect(function () {
      if (!state.mounted) return;
      var disclosure = state.disclosureRef.current;
      if (!disclosure) return;
      if (!isButton(disclosure)) return;

      var onMouseDown = function onMouseDown() {
        var receivedFocus = false;

        var onFocus = function onFocus() {
          receivedFocus = true;
        };

        var options = {
          capture: true,
          once: true
        };
        disclosure.addEventListener("focusin", onFocus, options);
        queueBeforeEvent(disclosure, "mouseup", function () {
          disclosure.removeEventListener("focusin", onFocus, true);
          if (receivedFocus) return;
          focusIfNeeded(disclosure);
        });
      };

      disclosure.addEventListener("mousedown", onMouseDown);
      return function () {
        disclosure.removeEventListener("mousedown", onMouseDown);
      };
    }, [state.mounted, state.disclosureRef]);
  } // Renders a hidden dismiss button at the top of the modal dialog element.
  // So that screen reader users aren't trapped in the dialog when there's no
  // visible dismiss button.


  useEffect(function () {
    if (!state.mounted) return;
    if (!domReady) return;
    var dialog = ref.current;
    if (!dialog) return; // Usually, we only want to force the presence of a dismiss button if the
    // dialog is a modal. But, on Safari, since we're disabling the
    // accessibility tree outside, we need to ensure the user will be able to
    // close the dialog.

    if (shouldDisableAccessibilityTree) {
      // If there's already a DialogDismiss component, it does nothing.
      var existingDismiss = dialog.querySelector("[data-dialog-dismiss]");
      if (existingDismiss) return;
      return prependHiddenDismiss(dialog, state.hide);
    }

    return;
  }, [state.mounted, domReady, shouldDisableAccessibilityTree, state.hide]);
  var shouldDisableOutside = useChampionDialog(ref, "data-dialog-disable-outside", openStable && !openModals.length && shouldDisableAccessibilityTree); // Disables/enables the element tree around the modal dialog element.

  useSafeLayoutEffect(function () {
    // When the dialog is animating, we immediately restore the element tree
    // outside. This means the element tree will be enabled when the focus is
    // moved back to the disclosure element.
    if (!shouldDisableOutside()) return; // If portal is enabled, we get the portalNode instead of the dialog
    // element. This will consider nested dialogs as they will be children of
    // the portal node, but not the dialog. This also accounts for the tiny
    // delay before the dialog element is appended to the portal node, and the
    // portal node is added to the DOM.

    var element = portal ? portalNode : ref.current;

    if (modal) {
      return chain(disableAccessibilityTreeOutside(element), // When the backdrop is not visible, we also need to disable pointer
      // events outside of the modal dialog.
      !backdrop ? disablePointerEventsOutside(element) : null);
    }

    return disableAccessibilityTreeOutside(element);
  }, [shouldDisableOutside, portal, portalNode, modal, backdrop]);
  var prevInitialFocusRef = useRef();
  var mayAutoFocusOnShow = !!autoFocusOnShow;
  var autoFocusOnShowProp = useBooleanEvent(autoFocusOnShow); // Auto focus on show.

  useEffect(function () {
    var _nestedDialogsRef$cur;

    if (!openStable) return;
    if (!mayAutoFocusOnShow) return; // Makes sure to wait for the portalNode to be created before moving
    // focus. This is useful for when the Dialog component is unmounted
    // when hidden.

    if (!domReady) return; // If there are open nested dialogs, let them handle the focus.

    var hasNestedOpenDialog = (_nestedDialogsRef$cur = nestedDialogsRef.current) == null ? void 0 : _nestedDialogsRef$cur.some(function (child) {
      return child.current && !child.current.hidden;
    });
    if (hasNestedOpenDialog) return; // The dialog element may change for different reasons. For example, when
    // the `modal`, `portal` or `backdrop` props change, the HTML structure
    // will also change, which will affect the dialog element reference.
    // That's why we're listening to `state.contentElement` here instead of
    // getting the `ref.current` value. This ensures this effect will re-run
    // when the dialog element reference changes.

    var dialog = state.contentElement;
    if (!(dialog != null && dialog.isConnected)) return;
    var initialFocus = initialFocusRef == null ? void 0 : initialFocusRef.current;
    var element = initialFocus || // We have to fallback to the first focusable element otherwise portaled
    // dialogs with preserveTabOrder set to true will not receive focus
    // properly because the elements aren't tabbable until the dialog
    // receives focus.
    getFirstTabbableIn(dialog, true, portal && preserveTabOrder) || dialog;
    var prevInitialFocus = prevInitialFocusRef.current;
    prevInitialFocusRef.current = initialFocus; // If the initial focus is the same as the previous initial focus and
    // there's already an element with focus inside the dialog, we don't
    // change focus here.

    if (initialFocus === prevInitialFocus) {
      var activeElement = getActiveElement(dialog, true);
      if (activeElement && contains(dialog, activeElement)) return;
    }

    if (!autoFocusOnShowProp(element)) return;
    element.focus();
  }, [openStable, mayAutoFocusOnShow, domReady, state.contentElement, initialFocusRef, portal, preserveTabOrder, autoFocusOnShowProp]);
  var mayAutoFocusOnHide = !!autoFocusOnHide;
  var autoFocusOnHideProp = useBooleanEvent(autoFocusOnHide); // Auto focus on hide.

  useEffect(function () {
    var dialog = ref.current;
    var prevOpen = openRef.current;
    openRef.current = state.open; // We only want to auto focus on hide if the dialog was open before.

    if (!prevOpen) return;
    if (!mayAutoFocusOnHide) return;
    if (!dialog) return; // A function so we can use it on the effect setup and cleanup phases.

    var focusOnHide = function focusOnHide() {
      var dialogs = nestedDialogsRef.current; // Hide was triggered by a click/focus on a tabbable element outside
      // the dialog or on another dialog. We won't change focus then.

      if (isAlreadyFocusingAnotherElement(dialog, dialogs)) return;
      var element = (finalFocusRef == null ? void 0 : finalFocusRef.current) || state.disclosureRef.current;

      if (element) {
        if (element.id) {
          var doc = getDocument(element);
          var selector = "[aria-activedescendant=\"" + element.id + "\"]";
          var composite = doc.querySelector(selector); // If the element is an item in a composite widget that handles
          // focus with the `aria-activedescendant` attribute, we want to
          // focus on the composite element itself.

          if (composite) {
            element = composite;
          }
        } // If the element is not focusable by the time the dialog is hidden,
        // it's probably because it's an element inside another popover or
        // menu that also got hidden when this dialog was shown. We'll try to
        // focus on their disclosure element instead.


        if (!isFocusable(element)) {
          var parentDialog = closest(element, "[data-dialog]");

          if (parentDialog && parentDialog.id) {
            var _doc = getDocument(parentDialog);

            var _selector = "[aria-controls~=\"" + parentDialog.id + "\"]";

            var control = _doc.querySelector(_selector);

            if (control) {
              element = control;
            }
          }
        }

        if (!autoFocusOnHideProp(element)) return;
        element.focus();
      }
    };

    if (!state.open) {
      // If this effect is running while state.open is false, this means
      // that the Dialog component doesn't get unmounted when it's not
      // open, so we can immediatelly move focus.
      return focusOnHide();
    } // Otherwise, we just return the focusOnHide function so it's going to
    // be executed when the Dialog component gets unmounted. This is useful
    // so we can support both mounting and unmounting Dialog components.


    return focusOnHide;
  }, [mayAutoFocusOnHide, state.open, finalFocusRef, state.disclosureRef, autoFocusOnHideProp]);
  var hideOnEscapeProp = useBooleanEvent(hideOnEscape); // Hide on Escape.

  useEffect(function () {
    if (!domReady) return;
    if (!state.mounted) return;

    var onKeyDown = function onKeyDown(event) {
      var dialog = ref.current;
      if (!dialog) return;
      var target = event.target;
      var disclosure = state.disclosureRef.current;
      if (event.key !== "Escape") return;
      if (event.defaultPrevented) return;
      if (!target) return; // This considers valid targets only the disclosure element or
      // descendants of the dialog element that are not descendants of nested
      // dialogs.

      var isValidTarget = function isValidTarget() {
        if (contains(dialog, target)) {
          var dialogs = nestedDialogsRef.current; // Since this is a native DOM event, it won't be triggered by
          // keystrokes on nested dialogs inside portals. But we still need to
          // check if the target is inside a nested non-portal dialog.

          var inNestedDialog = dialogs.some(isInDialog(target));
          if (inNestedDialog) return false;
          return true;
        }

        if (disclosure && contains(disclosure, target)) return true;
        return false;
      };

      if (isValidTarget() && hideOnEscapeProp(event)) {
        state.hide();
      }
    }; // We're attatching the listener to the document instead of the dialog
    // element so we can also listen to keystrokes on the disclosure element.
    // We can't do this on a onKeyDown prop on the disclosure element because
    // we don't have access to the hideOnEscape prop there.


    return addGlobalEventListener("keydown", onKeyDown);
  }, [domReady, state.mounted, state.disclosureRef, hideOnEscapeProp, state.hide]); // Wraps the element with the nested dialog context.

  props = useWrapElement(props, wrapElement, [wrapElement]); // Resets the heading levels inside the modal dialog so they start with h1.

  props = useWrapElement(props, function (element) {
    return /*#__PURE__*/jsx(HeadingLevel, {
      level: modal ? 1 : undefined,
      children: element
    });
  }, [modal]); // Focus traps.

  props = useFocusTrapRegion(_objectSpread(_objectSpread({}, props), {}, {
    enabled: state.open && modal && !openModals.length
  }));
  var hiddenProp = props.hidden; // Wraps the dialog with a backdrop element if the backdrop prop is truthy.

  props = useWrapElement(props, function (element) {
    if (backdrop) {
      return /*#__PURE__*/jsx(DialogBackdrop, {
        state: state,
        backdrop: backdrop,
        backdropProps: backdropProps,
        hideOnInteractOutside: hideOnInteractOutside,
        hideOnEscape: hideOnEscape,
        hidden: hiddenProp,
        children: element
      });
    }

    return element;
  }, [state, backdrop, backdropProps, hideOnInteractOutside, hideOnEscape, hiddenProp]);

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      headingId = _useState6[0],
      setHeadingId = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2),
      descriptionId = _useState8[0],
      setDescriptionId = _useState8[1];

  props = useWrapElement(props, function (element) {
    return /*#__PURE__*/jsx(DialogContext.Provider, {
      value: state,
      children: /*#__PURE__*/jsx(DialogHeadingContext.Provider, {
        value: setHeadingId,
        children: /*#__PURE__*/jsx(DialogDescriptionContext.Provider, {
          value: setDescriptionId,
          children: element
        })
      })
    });
  }, [state]);
  props = _objectSpread(_objectSpread({
    id: id,
    "data-dialog": "",
    role: "dialog",
    tabIndex: focusable ? -1 : undefined,
    "aria-labelledby": headingId,
    "aria-describedby": descriptionId
  }, props), {}, {
    ref: useForkRef(ref, props.ref)
  });
  props = useDisclosureContent(_objectSpread({
    state: state
  }, props));
  props = useFocusable(_objectSpread(_objectSpread({}, props), {}, {
    focusable: focusable
  }));
  props = usePortal(_objectSpread(_objectSpread({
    portal: portal
  }, props), {}, {
    portalRef: portalRef,
    preserveTabOrder: preserveTabOrder
  }));
  return props;
});
/**
 * A component that renders a dialog element.
 * @see https://ariakit.org/components/dialog
 * @example
 * ```jsx
 * const dialog = useDialogState();
 * <button onClick={dialog.toggle}>Open dialog</button>
 * <Dialog state={dialog}>Dialog</Dialog>
 * ```
 */

var Dialog = createComponent(function (props) {
  var htmlProps = useDialog(props);
  return createElement("div", htmlProps);
});
export { Dialog, useDialog };